export default "__VITE_ASSET__CMD_iN7A__"